import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../Context/AuthContext";
import { Base_URL } from "../url";
import "../Styling/BankManagement.css";

const BankManagement = () => {
  const { user } = useAuth();

  const [countryCode, setCountryCode] = useState("IN");
  const [countryList, setCountryList] = useState([]);
  const [bank, setBank] = useState("");
  const [bankList, setBankList] = useState([]);
  const [selectedBanks, setSelectedBanks] = useState([]);
  const [savedBanks, setSavedBanks] = useState([]);


  // ==============================
  // 1️⃣ Fetch Country Codes
  // ==============================
  useEffect(() => {
    const fetchCountryCodes = async () => {
      try {
        const response = await axios.get(
          `${Base_URL}/BankCountryMaster/GetCountryCodes`
        );

        if (response.data.success === true) {
          setCountryList(response.data.data);
        } else {
          setCountryList([]);
        }
      } catch (error) {
        console.error("Error fetching country codes:", error);
        setCountryList([]);
      }
    };

    fetchCountryCodes();
  }, []);

  // ==============================
  // 2️⃣ Fetch Banks by Country
  // ==============================
  useEffect(() => {
    const fetchBanks = async () => {
      if (!countryCode) {
        setBankList([]);
        return;
      }

      try {
        const response = await axios.get(
          `${Base_URL}/BankCountryMaster/GetBanksByCountry`,
          {
            params: { countryCode: countryCode },
          }
        );

        if (response.data.success) {
          setBankList(response.data.data);
        } else {
          setBankList([]);
        }
      } catch (error) {
        console.error("Error fetching banks:", error);
        setBankList([]);
      }
    };

    fetchBanks();
  }, [countryCode]);


  const fetchSavedBanks = async () => {
    try {
      const response = await axios.get(
        `${Base_URL}/BankCountryMaster/GetOrgBankMapping`,
        {
          params: { orgid: user.organisationId }
        }
      );
  
      if (response.data.success) {
        setSavedBanks(response.data.data);
      } else {
        setSavedBanks([]);
      }
    } catch (error) {
      console.error("Error fetching saved banks:", error);
      setSavedBanks([]);
    }
  };

  
  useEffect(() => {
    if (user?.organisationId) {
      fetchSavedBanks();
    }
  }, [user]);
  
  

  // ==============================
  // 3️⃣ Add Bank to Selected List
  // ==============================
  const handleBankSelect = (e) => {
    const selectedBankId = e.target.value;
    if (!selectedBankId) return;
  
    const selectedBankObject = bankList.find(
      (b) => b.bankCountryMasterid.toString() === selectedBankId
    );
  
    if (!selectedBankObject) return;
  
    const alreadyExists = selectedBanks.some(
      (item) => item.bankCountryMasterGuid === selectedBankObject.bankCountryMasterGuid
    );
  
    if (!alreadyExists) {
      setSelectedBanks([...selectedBanks, selectedBankObject]);
    }
  
    setBank("");
  };


  const filteredBankList = bankList.filter((bankItem) => {
    const isSelected = selectedBanks.some(
      (selected) =>
        selected.bankCountryMasterGuid ===
        bankItem.bankCountryMasterGuid
    );
  
    const isSaved = savedBanks.some(
      (saved) =>
        saved.bankCountryMasterGuid ===
        bankItem.bankCountryMasterGuid
    );
  
    return !isSelected && !isSaved;
  });
  
  
  
  

  // ==============================
  // 4️⃣ Remove Bank
  // ==============================
  const removeBank = (bankToRemove) => {
    setSelectedBanks(
      selectedBanks.filter(
        (item) =>
          item.bankCountryMasterGuid !==
          bankToRemove.bankCountryMasterGuid
      )
    );
  };
  

  // ==============================
  // 5️⃣ Submit Button Logic
  // ==============================
  // ==============================
// 5️⃣ Submit Button Logic
// ==============================
const handleSubmit = async () => {
  try {
    const payload = selectedBanks.map((bank) => ({
      orgid: user.organisationId,
      bankMappingGuid: bank.bankCountryMasterGuid,
      isActive: false
    }));

    const response = await axios.post(
      `${Base_URL}/BankCountryMaster/SaveOrgBankMapping`,
      payload
    );

    // ✅ Clear selected list
    setSelectedBanks([]);

    // ✅ Refresh View Banks section
    fetchSavedBanks();

  } catch (error) {
    console.error("Error:", error);
  }
};


const handleDeactivateBank = async (bankGuid) => {
  try {
    await axios.post(
      `${Base_URL}/BankCountryMaster/DeactivateOrgBank`,
      null,
      {
        params: {
          bankGuid: bankGuid,
          orgid: user.organisationId
        }
      }
    );

    // Refresh view section
    fetchSavedBanks();

  } catch (error) {
    console.error("Error deactivating bank:", error);
  }
};
  

  return (
    <div className="bank-management-container">

      <div className="bank-management-title-card">
        <h2>Bank Management</h2>
      </div>

      <div className="bank-management-dropdown-card">
        <div className="bank-management-dropdown-row">

          {/* Country Code */}
          <div className="bank-management-form-group">
            <label>Country Code</label>
            <select
              value={countryCode}
              onChange={(e) => {
                setCountryCode(e.target.value);
                setBank("");
              }}
              className="bank-management-form-select"
            >
              {/* <option value="">Select Code</option> */}
              {countryList.map((code, index) => (
                <option key={index} value={code}>
                  {code}
                </option>
              ))}
            </select>
          </div>

          {/* Bank Name */}
          <div className="bank-management-form-group">
            <label>Bank Name</label>
            <select
              value={bank}
              onChange={handleBankSelect}
              className="bank-management-form-select"
              disabled={!countryCode}
            >
              <option value="">Select Bank</option>

              {filteredBankList.map((bankItem) => (
                <option
                  key={bankItem.bankCountryMasterid}
                  value={bankItem.bankCountryMasterid}
                >
                  {bankItem.bankName}
                </option>
              ))}
            </select>

          </div>

        </div>
      </div>

      {/* Selected Banks Section */}
      <div className="bank-management-chip-container">
        <label className="bank-management-chip-label">Selected Banks</label>

        <div className="bank-management-chip-wrapper">
        {selectedBanks.map((item) => (
          <div key={item.bankCountryMasterGuid} className="bank-management-chip">


              <span>
                {item.bankName} ({item.countryCode})
              </span>

              <span
                className="bank-management-chip-close"
                onClick={() => removeBank(item)}
              >
                ✕
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* ================= SUBMIT BUTTON ================= */}
      <div style={{ marginTop: "20px", textAlign: "right" }}>
        <button
          onClick={handleSubmit}
          className="bank-management-submit-btn"
        >
          Submit
        </button>
      </div>

      {/* ================= VIEW BANKS SECTION ================= */}
        <div className="bank-management-view-banks-card">
          <div className="bank-management-view-banks-header">
            <h3>View Banks</h3>
          </div>

          {savedBanks.length === 0 ? (
            <div className="no-banks">
              No active banks saved for this organization.
            </div>
          ) : (
            <div className="bank-management-view-chip-wrapper">
              {savedBanks.map((bank) => (
                <div key={bank.bankCountryMasterGuid} className="bank-management-view-bank-chip">

                  <span className="bank-management-view-bank-name">
                    {bank.bankName}
                  </span>

                  <span
                    className="bank-management-view-chip-close"
                    onClick={() =>
                      handleDeactivateBank(bank.bankCountryMasterGuid)
                    }
                  >
                    ✕
                  </span>

                </div>
              ))}
            </div>
          )}
        </div>




    </div>
  );
}

export default BankManagement;
